export const COS_BIZ_TYPE = {
    DOC_UPLOAD: 1,
    DOC_DOWNLOAD: 2,
    IMG_UPLOAD: 3,
    IMG_DOWNLOAD: 4,
    AVATAR_UPLOAD: 5,
    AVATAR_DOWNLOAD: 6
};



// WEBPACK FOOTER //
// ./src/constants/file-import.js